import { AutoRFQApi, AxiosMethods, RFQApi } from '@setvi/shared/enums';
import { axiosHelper } from '@setvi/shared/services';

export enum RFQueryKey {
  PRODUCTS = 'PRODUCTS',
  FILE_RESULTS = 'FILE_RESULTS',
  FILES_STATUES = 'FILES_STATUES'
}

export const getProductsByJobId = (jobId: string) => ({
  queryKey: [RFQueryKey.PRODUCTS, jobId],
  queryFn: () =>
    axiosHelper({
      endpoint: RFQApi.GetProductsById,
      method: AxiosMethods.GET,
      baseURL: process.env.INTELLIGENCE_API_BASE_URL,
      headers: {
        Accept: 'text/plain'
      },
      params: { jobId }
    }),
  retry: 3
});

export const getProductsByStatusId = (statusId: string) => ({
  queryKey: [RFQueryKey.PRODUCTS, statusId],
  queryFn: () =>
    axiosHelper({
      endpoint: AutoRFQApi.GetRFQResults,
      method: AxiosMethods.GET,
      baseURL: process.env.INTELLIGENCE_API_BASE_URL,
      headers: {
        Accept: 'text/plain'
      },
      params: { statusId }
    }),
  retry: 3
});

export const getFilesStatusesQuery = (rfqId: string) => ({
  queryKey: [RFQueryKey.FILES_STATUES, rfqId],
  queryFn: () =>
    axiosHelper({
      endpoint: RFQApi.GetFilesStatuses,
      method: AxiosMethods.GET,
      baseURL: process.env.INTELLIGENCE_API_BASE_URL,
      headers: {
        Accept: 'text/plain'
      },
      params: { rfqId }
    })
});
